import React, { memo } from 'react';
import { useMediaQuery, Box } from "@mui/material"
import { useTheme } from '@mui/material/styles';

import loginFormImg from 'assets/images/login-form.png'
import AnimatedSection from 'components/animationComponents/animatedSection';

const FullScreenContentImgSection = () => {

  const theme = useTheme();
  const mediaQueryMidAndUp = useMediaQuery(theme.breakpoints.up('md'));

  if (!mediaQueryMidAndUp) return null

  return (
    <Box m={0} p={2} sx={{ display: "flex", flexDirection: "column", alignItems: "stretch", flex: 1 }}>
      <AnimatedSection>
        <img src={`${loginFormImg}?w=162&auto=format`} srcSet={`${loginFormImg}?w=162&auto=format&dpr=2 2x`} alt='login-form' loading="lazy"
          style={{ borderRadius: theme.shape.borderRadius, width: "100%", height: "100%", objectFit: "cover" }} />
      </AnimatedSection>
    </Box>
  )
}

export default memo(FullScreenContentImgSection);